import axiosClient from './apiClient';

export const getBestSellerById = (id: string, data: any) => {
  const headers: Record<string, string> = { };
  if (data.subpath) headers['subpath'] = data.subpath;
  if (data.currencyCode) headers['currency-code'] = data.currencyCode;
  return axiosClient.post(`/api/v2/product/bestseller/${id}`, data, { headers });
};

export const getScreensaver = (subpath?: string | null) => {
  const headers: Record<string, string> = { Accept: 'application/json' };
  if (subpath) headers['subpath'] = subpath;
  return axiosClient.get('/api/admin/v1/getScreensaver', { headers });
};
